let verify = {
    authenticationFailed: "Verification failed",
    authenticationSuccess: "Verification succeeded",
    turnClick: "Please click",
    explain: "Swipe right to complete verification",
    safetyVerification: "Please complete security verification",
}

export default verify